import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { Heart } from 'lucide-react';
export function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<'terms' | 'privacy'>('terms');
  const openModal = (content: 'terms' | 'privacy') => {
    setModalContent(content);
    setModalOpen(true);
  };
  const currentYear = new Date().getFullYear();
  return <footer className="bg-warm-900 text-cream-100 py-16 px-4 border-t border-warm-800" data-id="element-19">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-10" data-id="element-20">
        <div className="text-center md:text-left" data-id="element-21">
          <h4 className="text-2xl font-bold text-peach-300 mb-3 flex items-center justify-center md:justify-start gap-2" data-id="element-22">
            Transforma tus Finanzas
            <Heart className="w-5 h-5 text-coral-500 fill-current" data-id="element-23" />
          </h4>
          <p className="text-warm-200 text-sm max-w-xs" data-id="element-24">
            Hecho con cariño para ayudarte a construir la vida que mereces.
          </p>
          <p className="text-warm-500 text-xs mt-4" data-id="element-25">
            © {currentYear} Todos los derechos reservados.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-8 text-sm text-warm-200" data-id="element-26">
          <button onClick={() => openModal('terms')} className="hover:text-peach-300 transition-colors underline decoration-warm-700 underline-offset-4 hover:decoration-peach-300" data-id="element-27">
            Términos y Condiciones
          </button>
          <button onClick={() => openModal('privacy')} className="hover:text-peach-300 transition-colors underline decoration-warm-700 underline-offset-4 hover:decoration-peach-300" data-id="element-28">
            Política de Privacidad
          </button>
        </div>
      </div>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={modalContent === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'} data-id="element-29">
        {modalContent === 'terms' ? <div className="space-y-4 text-warm-800" data-id="element-30">
            <p data-id="element-31">
              <strong data-id="element-32">1. Uso del Producto Digital</strong>
              <br data-id="element-33" />
              Al comprar "Transforma tus Finanzas en 30 días", adquieres una
              licencia personal e intransferible para usar el ebook y la
              plantilla. Queda prohibida su distribución, reventa o copia no
              autorizada.
            </p>

            <p data-id="element-34">
              <strong data-id="element-35">2. Política de Reembolso</strong>
              <br data-id="element-36" />
              Debido a la naturaleza digital del producto (descarga inmediata),
              todas las ventas son finales. Sin embargo, si tienes problemas
              técnicos con la descarga, nuestro equipo de soporte te ayudará
              inmediatamente.
            </p>

            <p data-id="element-37">
              <strong data-id="element-38">3. Descargo de Responsabilidad</strong>
              <br data-id="element-39" />
              Este material es educativo. No constituye asesoramiento financiero
              profesional personalizado. Los resultados pueden variar según el
              compromiso y la situación individual de cada persona.
            </p>

            <p data-id="element-40">
              <strong data-id="element-41">4. Propiedad Intelectual</strong>
              <br data-id="element-42" />
              Todo el contenido, diseño y material gráfico está protegido por
              derechos de autor.
            </p>
          </div> : <div className="space-y-4 text-warm-800" data-id="element-43">
            <p data-id="element-44">
              <strong data-id="element-45">1. Recopilación de Información</strong>
              <br data-id="element-46" />
              Solo recopilamos la información necesaria para procesar tu compra
              y enviarte el producto (nombre y correo electrónico).
            </p>

            <p data-id="element-47">
              <strong data-id="element-48">2. Uso de la Información</strong>
              <br data-id="element-49" />
              Tu información se utiliza exclusivamente para entregarte el
              producto, enviarte actualizaciones relacionadas y soporte al
              cliente. No vendemos ni compartimos tus datos con terceros.
            </p>

            <p data-id="element-50">
              <strong data-id="element-51">3. Seguridad</strong>
              <br data-id="element-52" />
              Utilizamos plataformas de pago seguras y encriptadas. No
              almacenamos datos de tarjetas de crédito en nuestros servidores.
            </p>

            <p data-id="element-53">
              <strong data-id="element-54">4. Cookies</strong>
              <br data-id="element-55" />
              Utilizamos cookies esenciales para el funcionamiento del sitio y
              el proceso de compra.
            </p>
          </div>}
      </Modal>
    </footer>;
}